import { useEffect } from 'react';
import api from '../api';

function DocumentTitle() {
  useEffect(() => {
    api.get('/api/settings/public')
      .then(res => {
        const name = res.data?.site_name;
        if (name) {
          document.title = name;
        }
      })
      .catch(() => {});
  }, []);

  return null;
}

export default DocumentTitle;
